import { Page } from '@/core/architecture'

import { ConsoleDeliveryManagementTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleDeliveryManagement Page
 * Implemented as a practical sample.
 */
export const ConsoleDeliveryManagement: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleDeliveryManagementTemplate state={state} {...actions} />
}
